/**
 * Runs before i18n init so ?fresh=1 can clear storage before locale is read from localStorage.
 */
import { clearPlatformStorage } from '@utils/resetStorage';

if (typeof window !== 'undefined') {
  try {
    const u = new URL(window.location.href);
    if (u.searchParams.get('fresh') === '1') {
      clearPlatformStorage();
      window.location.replace(`${u.origin}/`);
    }
  } catch {
    /* ignore */
  }
}
